import store from './store/index.js'
import { createRouter, createWebHistory } from "vue-router";

// import HomePage from "./components/pages/durraHome";
import HomePage from "./components/pages/NewHome.vue";
import copy from "./components/pages/copy.vue";
import test from "./components/layouts/cardComponent.vue";
import forgotPassword from "./components/pages/ForgotPassword.vue";
import resetPassword from "./components/pages/resetPassword.vue";




import Login from "./components/pages/login.vue";
import activateAccount from "./components/pages/activateAccount.vue";

import Signup from "./components/pages/RegisterUser.vue";
import DashboardPage from "./components/pages/newDashboard.vue";
import registerClient from "./components/pages/registerClient.vue";
import allClients from "./components/pages/allClients.vue";
import collections from "./components/pages/collections.vue";
import empire from "./components/pages/empire.vue";
import friday from "./components/pages/Friday.vue";
import hvock from "./components/pages/hvock.vue";


import newCampaign from "./components/pages/Createcampaign.vue";

import clientCollections from "./components/pages/clientCollections.vue";


import userRegistration from "./components/pages/NewRegistration.vue";
import campaignCollections from "./components/pages/campaignCollections.vue";
import ShuffleWinner from './components/layouts/shuffleWinner.vue';



// import allTrades from "./components/pages/allTrades.vue"
















const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: "/", component: HomePage },
    { path: "/legends", component: friday },
    { path: "/client/collections", component: clientCollections },
    { path: "/forgot/password", component: forgotPassword },
    { path: "/reset/password/:token", component: resetPassword },


    
    { path: "/test", component: test },
    { path: "/activate", component: activateAccount },
    { path: "/shuffle", component: ShuffleWinner, meta: {
      requiresAuth: true
    }  },


  
   
    { path: "/user/registration/", component: userRegistration },
    { path: "/login/", component: Login },
    { path: "/signup/", component: Signup },
    { path: "/dashboard/", component: DashboardPage, meta: {
      requiresAuth: true
    } },
    { path: "/new/campaign", component: newCampaign, meta: {
      requiresAuth: true
    } },
    { path: "/copy/", component: copy, meta: {
      requiresAuth: true
    } },
    { path: "/register/client", component: registerClient, meta: {
      requiresAuth: true
    } },
    { path: "/clients", component: allClients, meta: {
      requiresAuth: true
    } },
    { path: "/collections", component: collections

    //   , meta: {
    //   requiresAuth: true
    // }
   },
   { path: "/empire", component: empire

    //   , meta: {
    //   requiresAuth: true
    // }
   },
      { path: "/hvock", component: hvock

    //   , meta: {
    //   requiresAuth: true
    // }
   },
    
    { path: "/campaign/:account", component: campaignCollections, meta: {
      requiresAuth: true
    } },
   
    


    // {path: "/dashboard", component:DashBoard, meta: {
    //   requiresAuth: true
    // }},



    
   
    

  ],
});
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
   
    if (!store.getters.isLoggedIn) {
      next({ path: '/login' })
    } else {
      next() 
    }
    // console.log(`Navigating to: ${to.fullPath}`);

  } else {
    // console.log(`Navigating to: ${to.fullPath}`);
    next() 
  }
})

export default router;
